import { IMenuClass } from '../../../../../core/services/menu/menu.service';
import { IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IRoute } from '../../../../../core/interfaces/route.interface';

interface IPageMr0063 {
    multiOccurrenceOptions: IMultiOccurrenceOptions;
}

/* @ngInject */
export default function Mr0063Controller(Menu: IMenuClass,
        Formulaire: IFormulaireClass,
        FormulaireItem: IFormulaireItemClass,
        mr2029Route:IRoute
    ) {
    const vm: IPageMr0063 = this;

    vm.multiOccurrenceOptions = {
        navigatePage:mr2029Route.NAME,
        fonctions: {
            rechercheCollapsable: false
        },
       colonnesFixesGauche: [
            { nom: 'tytcleint', largeur: 60 },
            { nom: 'tytcod', largeur: 150 },
            { nom: 'tytdsc', largeur: 150 },
            { nom: 'stamnetab', largeur: 120 },
            { nom: 'vaetytregdsc', largeur: 300 }
        ],
        colonnesVisibles: [
            { nom: 'ecrcod', largeur: 110 },
            { nom: 'ecrdsc', largeur: 300 },
            { nom: 'tydcod', largeur: 300 },
            { nom: 'tyddsc', largeur: 300 },
            { nom: 'tytflgttcuni', largeur: 100 },
            { nom: 'tytflglogeva', largeur: 100 }
        ]
    };
}
